import './menu_panel.less';
import { Link }          from 'framework7-react';
import { useEffect }     from 'react';
import { useRef }        from 'react';
import classnames        from 'classnames';
import LocationLinks     from './location_links';
import NotificationBadge from '../components/notification_badge';
import React             from 'react';


export default function MenuPanel({ tab, businessID, navigateTo, userName, business, locations, needsOnboarding, closeMenu }) {
  const isMultipleLocation = locations?.length > 1;

  return (
    <div className="menu-panel">
      <div className="menu-panel-top">
        <Logo {...{ closeMenu }}/>
        {business && !isMultipleLocation && <SingleLocation location={business} {...{ tab, closeMenu }}/>}
        {business && isMultipleLocation && <MultipleLocations {...{ tab, businessID, navigateTo, locations, closeMenu, needsOnboarding }}/>}
      </div>
      <div className="menu-panel-bottom">
        <AccountLink {...{ businessID, userName, tab, closeMenu }}/>
      </div>
    </div>
  );
}


function Logo({ closeMenu }) {
  return <div className="logo" onClick={closeMenu}/>;
}


function SingleLocation({ location, tab, closeMenu }) {
  const { name } = location;
  const { id }   = location;
  return (
    <div className="single-location scrollable">
      <SingleLocationHeader name={name}/>
      <LocationLinks businessID={id} {...{ tab, closeMenu }}/>
    </div>
  );
}

function SingleLocationHeader({ name }) {
  return (
    <div className="single-location-header">
      <h4 className="small-caps">Location</h4>
      <p className="under-small-caps">{name}</p>
    </div>
  );
}

function MultipleLocations({ tab, businessID, navigateTo, locations, closeMenu, needsOnboarding }) {
  const currentLocation = locations.find(({ id }) => id === businessID);
  const otherLocations  = locations.filter(({ id }) => id !== businessID);
  const ref             = useRef();

  useEffect(function scrollUpWhenLocationChanges() {
    if (ref.current && typeof ref.current.scrollTo === 'function')
      ref.current.scrollTo(0, 0);
  }, [ businessID ]);

  return (
    <div className="multiple-locations scrollable" ref={ref}>
      <CurrentLocation location={currentLocation} {...{ tab, closeMenu, needsOnboarding }}/>
      <OtherLocations locations={otherLocations} {...{ navigateTo }}/>
    </div>
  );
}

function CurrentLocation({ location, tab, closeMenu, needsOnboarding }) {
  const { name } = location;
  const { id }   = location;
  return (
    <div className="current-location">
      <div className="multiple-location-header">{name}</div>
      {!needsOnboarding && <LocationLinks businessID={id} {...{ tab, closeMenu }}/>}
    </div>
  );
}

function OtherLocations({ locations, navigateTo }) {
  return (
    <div className="other-locations">
      {locations.map(location => <OtherLocationHeader key={location.id} location={location} navigateTo={navigateTo}/>)}
    </div>
  );
}

function OtherLocationHeader({ location, navigateTo }) {
  const { name }   = location;
  const { id }     = location;
  const href       = `/${id}/inbox`;
  const badgeCount = location?.unreadCount?.customers ?? 0;

  function onClick() {
    navigateTo(href);
  }

  return (
    <div className="multiple-location-header" role="tab" onClick={onClick}>
      <span>{name}</span>
      <NotificationBadge className="badge-count" color="red" count={badgeCount}/>
    </div>
  );
}

function AccountLink({ businessID, userName, tab, closeMenu }) {
  const active    = (tab === 'account');
  const className = classnames('tab-link', { 'tab-link-active': active });
  const href      = `/${businessID}/account`;

  return (
    <div className="account-link">
      <Link className={className} href={href} role="tab" onClick={closeMenu}>
        <h4 className="small-caps">Logged in as</h4>
        <p className="under-small-caps">{userName}</p>
      </Link>
    </div>
  );
}
